// @ts-nocheck
/* eslint-disable */

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.graphs = void 0;

var _colors = require('./colors.theme');

var graphs = {
  barGauge: {
    colorMapping: [
      {
        min: 0,
        max: 20,
        color: _colors.colors.warning1
      },
      {
        min: 21,
        max: 40,
        color: _colors.colors.warning2
      },
      {
        min: 41,
        max: 60,
        color: _colors.colors.success1
      },
      {
        min: 61,
        max: 80,
        color: _colors.colors.success2
      },
      {
        min: 81,
        max: 100,
        color: _colors.colors.success3
      }
    ],
    radius: '16px',
    height: '1rem'
  }
};
exports.graphs = graphs;
